export function isDateUTC(transactionDate) {
  // Verifica se a string termina com "Z" (UTC) ou "+00:00"
  if (!transactionDate.endsWith('Z') && !transactionDate.endsWith('+00:00')) {
    return false;
  }
  return transactionDate.endsWith('Z') || transactionDate.endsWith('+00:00');
}

